import { render, staticRenderFns } from "./Companion.vue?vue&type=template&id=d772a17e&"
import script from "./Companion.vue?vue&type=script&lang=js&"
export * from "./Companion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports